import Vue from 'vue'
import localstorage from '../../../plugins/localstorage'
import { app } from '../../../config'
import {userGSKStorageKey} from "../../../config/app";

export default {
  'SET_SURVEY' (state, value) {
    state.survey = value
    localstorage.setItem('survey', value)
  },
  'SET_TOKEN' (state, value) {
    state.token = value
    localstorage.setItem(app.userTokenStorageKey, value)
    Vue.http.headers.common['Authorization'] = `Bearer ${value}`
  },
  'SET_GSK' (state, value) {
    state.gsk = value
    localstorage.setItem(app.userGSKStorageKey, value)
  },
  'CLEAN_GOOGLE_SECRET_KEY' (state) {
    state.gsk = null
    localstorage.removeItem(app.userGSKStorageKey)
  },
  // eslint-disable-next-line no-unused-vars
  'LOGOUT' (state) {
    state = []
  },
  'CLEAN_USER' (state) {
    state.user = {}
    state.tenants = {}
    state.currentTenant = {}
    state.amountAccounts = {}
    state.amountTenants = {}
    state.permissions = {}
    state.currentAccount = {}
  },
  'SET_USER' (state, value) {
    state.user = value
  },
  'SET_USER_AVATAR' (state, value) {
    state.user.avatar = value
  },
  'SET_CURRENT_TENANT' (state, value) {
    state.tenant = value
  },
  'SET_CURRENT_ACCOUNT' (state, value) {
    
    state.currentAccount = value
  },
  'SET_CURRENT_PERMISSION' (state, value) {
    state.permissions = value
  },
  'SET_COLOR_THEME' (state, value) {
    state.colorTheme = value
  }
  // 'SET_CURRENT_PERMISSION' (state, value) {
  //   let per = value.role.data.permissions.data
  //   let datePer = []
  //   per.map(function (e, index) {
  //     datePer[index] = e.permission
  //   })
  //   state.permissions = datePer
  // }
}
